var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoConformeValidato(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z",
    fill: "#C8F6E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7961 6.27029C11.1287 5.90995 11.6686 5.90986 12.0011 6.27029C12.3296 6.62635 12.3333 7.20183 12.0129 7.56326L7.47966 13.7049C7.47317 13.7136 7.46649 13.7223 7.45915 13.7302C7.12658 14.0907 6.58665 14.0907 6.25408 13.7302L3.24919 10.4724C2.91695 10.112 2.91692 9.52815 3.24919 9.16775C3.58176 8.80727 4.12071 8.80729 4.45329 9.16775L6.83122 11.7439L10.7736 6.29861C10.7806 6.28892 10.788 6.27899 10.7961 6.27029Z",
    fill: "#008055"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5461 6.27127C15.8786 5.9108 16.4176 5.91079 16.7502 6.27127C17.0786 6.62733 17.0823 7.20184 16.7619 7.56326L12.2297 13.7049C12.2232 13.7136 12.2155 13.7224 12.2082 13.7302C11.8756 14.0903 11.3365 14.0906 11.0041 13.7302L9.95525 12.5935L11.0256 11.1443L11.5802 11.7449L15.5236 6.29861C15.5305 6.28916 15.5382 6.27978 15.5461 6.27127Z",
    fill: "#008055"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoConformeValidato);
export default __webpack_public_path__ + "static/media/ico-conforme-validato.c1dd0af34fcac6dc1c89f7d979860986.svg";
export { ForwardRef as ReactComponent };